import { Box } from 'rebass/styled-components'
import styled from 'styled-components'

export const Row = styled(Box)`
  width: 100%;
  display: flex;
  padding: 0;
  justify-content: flex-start;
  align-items: center;
`

export const RowClickable = styled(Row)`
  cursor: pointer;
`

export const RowBetween = styled(Row)`
  justify-content: space-between;
`

export const RowCenter = styled(Row)`
  justify-content: center;
`

export const RowHomePage = styled(Row)`
  margin-left: 50px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
  justify-content: center;
  margin-left: 0;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
  flex-direction: column;
  `};
`
export const RowFixed = styled(Row)`
  width: fit-content;
  margin: ${({ gap }) => gap && `-${gap}`};
  display: flex;
  align-items: center;
`
export const RowInput = styled(Row)`
  box-shadow: ${(props) =>
    !props.isDark && 'inset -8px -8px 20px 0 #ffffff, inset 8px 8px 20px 0 #d0d8e6'};
  background-color: ${(props) => props.isDark && 'rgba(154, 174, 173, 0.08)'};
  border-radius: ${(props) => (props.isDark ? '6px' : '50px')};
  height: 50px;
  align-items: center;
  padding: 0 11px 0 30px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
  padding-left: 20px;
  `}
`
